export const AWS_BUCKET_ENV ="PROD" ;

export const AWS_BUCKET_NAME ="atlas-patrimonial-bucket"
